/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginGetSuccess
 */
export interface LoginGetSuccess {
    /**
     * 
     * @type {number}
     * @memberof LoginGetSuccess
     */
    codeTtl: number;
    /**
     * 
     * @type {number}
     * @memberof LoginGetSuccess
     */
    renewTimeout: number;
    /**
     * 
     * @type {boolean}
     * @memberof LoginGetSuccess
     */
    usePassword: boolean;
}

export function LoginGetSuccessFromJSON(json: any): LoginGetSuccess {
    return LoginGetSuccessFromJSONTyped(json, false);
}

export function LoginGetSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginGetSuccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codeTtl': json['codeTtl'],
        'renewTimeout': json['renewTimeout'],
        'usePassword': json['usePassword'],
    };
}

export function LoginGetSuccessToJSON(value?: LoginGetSuccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codeTtl': value.codeTtl,
        'renewTimeout': value.renewTimeout,
        'usePassword': value.usePassword,
    };
}


